<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <NuxtPage />
</template>

<style>
p {
  @apply text-lg;
}
</style>